import { faSlidersSolid } from '@/lib/fa'
import CheckboxWithLabelField from '@/modules/drivers/forms/contract/inputs/CheckboxWithLabelField'
import { Divider } from '@/modules/drivers/forms/shared/Divider'
import StageHeader from '@/modules/drivers/forms/shared/StageHeader'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import React from 'react'
import SignatureFields from '../../SignatureFields'

// PDF i CSV wykluczaja sie jak setery PrintToSeparateFiles/PrintToSeparateCsvFiles w WPF
const Options = ({
  data,
  setData,
  vehicleActivity,
  separateFilesOnly,
  separateCsvFiles = false,
}: {
  data: any
  setData: any
  vehicleActivity?: boolean
  separateFilesOnly?: boolean
  separateCsvFiles?: boolean
}) => {
  const { t } = useLocalize()
  const setSeparate = (field: string, other: string) => (checked: boolean) =>
    setData({ ...data, [field]: checked, ...(checked ? { [other]: false } : {}) })
  return (
    <div className="tw-flex tw-items-start">
      <StageHeader title={t('printout.options')} textSize="sm" icon={faSlidersSolid} />
      <div className="tw-flex tw-flex-1 tw-flex-col tw-gap-1 sm:tw-min-w-[400px]">
        {vehicleActivity && (
          <>
            <CheckboxWithLabelField
              field="onlyForActiveVehicles"
              data={data}
              setData={setData}
              label={t('printout.only-active-vehicles')}
            />
            <Divider />
          </>
        )}
        {separateCsvFiles ? (
          <>
            <CheckboxWithLabelField
              value={Boolean(data?.separateFiles)}
              onChange={setSeparate('separateFiles', 'separateCsvFiles')}
              label={t('printout.print-to-separate-pdf-files')}
            />
            <CheckboxWithLabelField
              value={Boolean(data?.separateCsvFiles)}
              onChange={setSeparate('separateCsvFiles', 'separateFiles')}
              label={t('printout.print-to-separate-csv-files')}
            />
          </>
        ) : (
          <CheckboxWithLabelField
            field="separateFiles"
            data={data}
            setData={setData}
            label={t('printout.print-to-separate-files')}
          />
        )}
        <SignatureFields />
        {/* 
        {!separateFilesOnly && (
          <>
            <CheckboxWithLabelField
              field="issuerSignature"
              data={data}
              setData={setData}
              label={t('printout.issuer-signature')}
            />
            <CheckboxWithLabelField
              field="driverSignature"
              data={data}
              setData={setData}
              label={t('printout.driver-signature')}
            />
          </>
        )}
        */}
      </div>
    </div>
  )
}

export default Options
